import React from "react";
import { ChevronRight } from "lucide-react";
import { useIntl } from "react-intl";
import "./ScrollToEndButton.sass";

const ICON_SIZE = 16;

/**
 * «›» in the bottom right corner of the chart pane, next to the price axis:
 * shown by the parent while the latest bar is out of view.
 *
 * @param {object} props
 * @param {number} props.priceAxisWidth - CSS px, the button stays left of the axis
 * @param {() => void} props.onClick - slides the chart back to the latest bar
 */
const ScrollToEndButton = ({ priceAxisWidth, onClick }) => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: "futures.chart.scroll_to_end" });

  return (
    <button
      type="button"
      className="scroll-to-end-button"
      style={{ "--price-axis-width": `${priceAxisWidth}px` }}
      aria-label={label}
      title={label}
      onClick={onClick}
    >
      <ChevronRight size={ICON_SIZE} aria-hidden="true" />
    </button>
  );
};

export default ScrollToEndButton;
